import { Component, ViewEncapsulation, Injector, ViewChild, OnInit, ElementRef } from '@angular/core';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { AppComponentBase } from '@shared/common/app-component-base';
import { RegistrationsServiceProxy, EventTypesServiceProxy, RegistrationEventDto } from '@shared/service-proxies/service-proxies';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SubscriptionSituationType, PaymentChargeStatus } from '@shared/AppEnums';
import { CertificateModalComponent } from '@app/event/my-registrations/modal/certificate-modal.component';
import * as moment from 'moment';

@Component({  
  templateUrl: './my-registrations.component.html',
  styleUrls: ['./theme2.css'],
  encapsulation: ViewEncapsulation.None,
  animations: [appModuleAnimation()]
})
export class MyRegistrationsComponent extends AppComponentBase implements OnInit {

  subscriptionSituationType = SubscriptionSituationType;
  paymentChargeStatus = PaymentChargeStatus;

  @ViewChild('certificateModal') certificateModal: CertificateModalComponent;
  @ViewChild('addeventatc') addeventatc: any;

  subscriptions = [];
  types = [];
  users = [];

  userId: number = abp.session.userId;
  filterEventType = undefined;
  filterSituation = undefined;
  filterStatus = undefined;
   today = moment().startOf('day');

  constructor(
    injector: Injector,
    private route: ActivatedRoute,
    private _registrationsService: RegistrationsServiceProxy,
    private _eventTypesService: EventTypesServiceProxy,
    private _activatedRoute: ActivatedRoute
  ) {
    super(injector);
   }

   ngOnInit() {

    this._eventTypesService.getEventTypesForSelect("").subscribe(result => {
      this.types = result.items;
    });

    this.filterStatus = this._activatedRoute.snapshot.queryParams['paymentChargeStatus'] || undefined;

    this.getSubscriptions();
   }
   
   ngAfterViewInit() {
    setTimeout(function(){this.addeventatc.refresh();}, 200);
   }

   getSubscriptions(): void {

    this.block('.m-portlet.m-portlet--full-height');

    this._registrationsService.getUserRegistrations(
      this.userId,
      this.filterEventType ? this.filterEventType : undefined,
      this.filterSituation,
      this.filterStatus,
      undefined
    )
    .finally(() => { 
      this.unBlock('.m-portlet.m-portlet--full-height');
      this.primengDatatableHelper.hideLoadingIndicator(); 
    })
    .subscribe(result => {
      this.subscriptions = result.items;  
      setTimeout(function(){this.addeventatc.refresh();}, 200);  
    });
  }

  allowCalendar(event: RegistrationEventDto){

    return event.allowGoogleCalendar || event.allowYahooCalendar || event.allowICalCalendar;

  }

}



// WEBPACK FOOTER //
// ./src/app/event/my-registrations/my-registrations.component.ts